import { toast } from "react-toastify";

const parseDRFError = (errorData) => {
  if (typeof errorData === "string") {
    return errorData;
  }

  if (errorData?.detail) {
    return errorData.detail;
  }

  if (errorData?.non_field_errors) {
    return errorData.non_field_errors.join(" ");
  }

  if (typeof errorData === "object") {
    return Object.entries(errorData)
      .map(
        ([field, messages]) =>
          `${field}: ${Array.isArray(messages) ? messages.join(" ") : messages}`
      )
      .join("\n");
  }

  return "An unexpected error occurred";
};

export const withNotification = async ({
  promise,
  successMessage = "Success",
  errorMessage = "Something went wrong",
  loadingMessage = "Loading...",
}) => {
  const toastId = toast.loading(loadingMessage);

  try {
    const result = await promise;
    toast.update(toastId, {
      render: successMessage,
      type: "success",
      isLoading: false,
      autoClose: 3000,
    });
    return result;
  } catch (err) {
    const drfMessage =
      parseDRFError(err?.response?.data) || err.message || errorMessage;
    toast.update(toastId, {
      render: drfMessage,
      type: "error",
      isLoading: false,
      autoClose: 5000,
    });
    throw err;
  }
};
